import { configureStore } from "@reduxjs/toolkit";
import themeReducer from "./themeSlice";
import authReducer from "./authSlice";
import generalSlice from "./generalSlice";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    auth: authReducer,
    general: generalSlice,
  },
});

// RTK tipi isteyenler için:
// export const RootState = store.getState;
// export const AppDispatch = store.dispatch;
